var DataBehavior = require('backbone-torso/modules/behaviors/DataBehavior');
var insurancePolicyCollection = require('./insurancePolicyCollection');

/**
 * Data Behavior hooked up to the insurance policy cache.
 * @class InsurancePolicyDataBehavior
 * @constructor
 */
module.exports = DataBehavior.extend({
  cache: insurancePolicyCollection
});
